









































import Vue from 'vue';
import { assertNever } from 'assert-never';
import { PageMode } from '@/main/utils/pageMode';
import { listName } from '@/main/store/listEditTypes';
import { types } from '@/main/store/external/types';

import CustomLink from './CustomLink.vue';
import { MenuItem } from './menu';
import { MENU_OJETEVOZY, RouteType } from './constants';

export default Vue.extend({
	name: 'MenuItem',
	components: { CustomLink },
	props: {
		item: { type: Object as () => MenuItem, required: true },
		isMain: { type: Boolean, required: true },
		index: { type: [String, Function], required: true },
		isCollapsed: { type: Boolean, default: false },
	},
	computed: {
		itemName(): string {
			switch (this.item.routeType) {
				case RouteType.external:
					return this.item.name;
				case RouteType.web:
					return this.item.name;
				default:
					return this.LocalizeMenu(this.item.name);
			}
		},
		isLeaf(): boolean {
			return this.item.items.length === 0;
		},
		indexCmp(): string {
			if (typeof this.index === 'function') {
				return this.index(this);
			}
			return this.index;
		},
		route(): { name: string | null, params?: {} } | string {
			const { route, routeType } = this.item;
			switch (routeType) {
				case RouteType.external:
					return String(route);
				case RouteType.web:
					return String(route);
				case RouteType.name:
					return { name: route as string };
				case RouteType.listName:
					return { name: listName(route! as string), params: { mode: PageMode.LIST } };
				case RouteType.url:
					return route!;
				case RouteType.method:
					return (route as (vue: Vue) => string)(this);
				default: return assertNever(routeType);
			}
		},
		sortedItems(): MenuItem[] {
			if (!this.item.orderAlphabetically) {
				if (this.dmsSys.AfterSalesPrp) {
					return this.item.items.filter(x => x.visible);
				}
					 return this.item.items;
			}
			const items: [string, MenuItem][] = [];
			this.item.items.forEach((item: MenuItem) => {
				const localizedName = this.LocalizeMenu(item.name);

				const index = items.findIndex(
					([lName]: [string, any]) => localizedName.localeCompare(lName) < 0,
				);

				items.splice(index === -1 ? items.length : index, 0, [localizedName, item]);
			});

			if (this.dmsSys.AfterSalesPrp) {
				return items.map((a: [string, MenuItem]) => a[1]).filter(x => x.visible);
			}

			return items.map((a: [string, MenuItem]) => a[1]);
		},
	},
	methods: {
		goToRoute() {
			if (this.item.routeType === RouteType.external) {
				this.$store.dispatch(`external/${types.actions.GO_TO_EXTERNAL_ROUTE}`, {
					route: this.route,
					isPreviousRouteInternal: !this.$route.path.includes(MENU_OJETEVOZY),
				});

				return;
			}

			if (this.item.routeType === RouteType.web) {
				window.open(String(this.route), '_blank');
			}
		},
	},
});
